import { useRef } from "react"
import { motion, useScroll, useTransform } from 'framer-motion'

import Image from 'next/image'

import { Button } from '../../../components/button/button'
import { HeaderShim } from '../../../global/header/header'

import CSS from './page-header.module.css'

export const PageHeader = () => {

    let ref = useRef(null)
    
    let  scroll  = useScroll({
        target: ref,
        offset: ['start start', 'end start']
    })
    let y = useTransform( scroll.scrollYProgress, [0, 1], ["0%", "30%"])

    return (
        <>
            {/* <HeaderShim/> */}

            <section ref={ref} className={CSS.layout}>

                <div className={`${CSS.headline} formatted bg-secondary px-lg`}>
                    <p className='fs-lg fw-600 lh-1'>Cesta za snem</p>
                    <p className='fs-2 fw-300 lh-1 caps'>(Journey to a Dream)</p>
                    <p className="fs-5 mt-sm">At The Bench, one of our core values is caring about our communities and environment. This has encouraged us to continuously, through our events and gatherings, develop opportunities where we can champion specific charity causes that either improve the lives of communities or protect the environment for future generations.</p>
                </div>

                <div className={CSS.hero}>
                    <motion.div className={CSS.heroWrapper} style={{ y }}>
                        <Image src={`/assets/theme/dream.png`} width={800} height={800} layout={`responsive`} />
                    </motion.div>
                </div>

            </section>

        </>
    )
}